import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Spinner } from 'react-bootstrap';

const baseURL = process.env.REACT_APP_BACKEND_API_URL || "";


function PresentationSheet() {
    const [presentation, setPresentation] = useState(null);
    const [factsheet, setFactsheet] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchPresentation = async () => {
            try {
                setLoading(true);
                const res = await axios.get(
                    `${baseURL}/api/presentations?populate=*`
                );

                const items = res.data?.data || [];
                if (!items.length) return;

                const item = items[0];
                const factsheet = items[1];

                setPresentation(item);
                setFactsheet(factsheet);
            } catch (err) {
                console.error("Error fetching presentation:", err);
                setPresentation(null);
                setFactsheet(null);
            } finally {
                setLoading(false);
            }
        };

        fetchPresentation();
    }, []);

    const pdfUrl = presentation?.pdf?.url
        ? `${baseURL}${presentation.pdf.url}`
        : null;

    const factsheetUrl = factsheet?.pdf?.url
        ? `${baseURL}${factsheet.pdf.url}`
        : null;

    const thumbnailUrl = presentation?.thumbnail?.url
        ? `${baseURL}${presentation.thumbnail.url}`
        : null;

    return (
        <section id="presentation" className="journal-section text-white">
            <Container fluid className="py-5">
                <Row className="justify-content-center align-items-center text-center gy-4 flex-wrap">

                    {/* Presentation */}
                    {loading ? (
                        <div className="d-flex flex-column align-items-center">
                            <Spinner animation="border" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </Spinner>
                            <p className="mt-2 mb-0">Loading presentation...</p>
                        </div>
                    ) : (pdfUrl && thumbnailUrl) ? (
                        <>
                            <Col
                                xs={12}
                                md="auto"
                                className="d-flex align-items-center justify-content-center"
                            >

                                <>
                                    <a href={pdfUrl} target="_blank" rel="noreferrer">
                                        <h3 className="mt-3 mb-3">PRESENTATION</h3>
                                    </a>
                                    <i className="fas fa-arrow-circle-right d-block mb-3"></i>
                                    <a href={pdfUrl} target="_blank" rel="noreferrer">
                                        <img
                                            className="img-fluid presentation"
                                            src={thumbnailUrl}
                                            alt="Presentation"
                                        />
                                    </a>
                                </>
                            </Col>

                            {/* Divider */}
                            <Col xs="auto" className="d-none d-md-block p-0">
                                <div className="divider mx-3"></div>
                            </Col>
                        </>
                    ) : (
                        null
                    )}

                    <Col xs={12} md="auto" className="d-flex align-items-center justify-content-center">
                        <a href="/q-gold-fact-sheet-apr-2026.pdf" target="_blank">
                            <img
                                className="img-fluid factsheet"
                                src="/images/investor-facts.png"
                                alt="Fact Sheet"
                            />
                        </a>
                        <i className="fas fa-arrow-circle-left d-block mt-3"></i>
                        <a href={factsheetUrl} target="_blank">
                            <h3 className="mt-3 mb-3">FACT SHEET</h3>
                        </a>
                    </Col>

                </Row>
            </Container>
        </section>
    );
}

export default PresentationSheet;
